import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H13.8464C12.4127 21.8077 11.5 20.0104 11.5 18C11.5 14.4101 14.4101 11.5 18 11.5C19.0821 11.5 20.1025 11.7644 21 12.2322V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 15C17.0694 15 16.5 15.6561 16.5 16.2489V17.2489H14.5V16.2489C14.5 14.3576 16.1692 13 18 13C19.8308 13 21.5 14.3576 21.5 16.2489C21.5 17.1643 21.0934 17.9745 20.4734 18.5489L19 19.9388V20.6223H17V19.0759L19.1123 17.0834C19.3677 16.8476 19.5 16.5523 19.5 16.2489C19.5 15.6561 18.9306 15 18 15ZM16.9991 21.9961H19.003V24H16.9991V21.9961Z"}}]};

const FileUnknownFilled = Vue.extend<IconProps>({
  name: 'FileUnknownFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'file-unknown-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FileUnknownFilled;
